// The five funnel presets. Each maps 1:1 to a `funnel_variant_<letter>` row in
// the DepthMe `feature_flags` table, which Admin → Settings toggles; the row's
// `rollout_pct` is the variant's weight in the random split.
// Copy for A is the depthme.zip landing page verbatim; the rest re-angle it.
//
// Hero videos, chosen from transcripts of the two ads:
//  ad-1 (53s) — the founder on the inner critic "always criticizing, always
//        judging", mental loops, and rewiring through repetition. Fits A
//        (original), C (the inner-critic pain) and D (short — it is the
//        shorter cut).
//  ad-2 (90s) — a first-person year of affirmations: "I am grateful, I am
//        powerful", reframing the morning, "become friends with your mind".
//        Fits B (saying it to yourself) and E (a real person's result).

export const APP_URL = 'https://depthme.app';

export const SECTIONS = ['problem', 'rituals', 'offer', 'proof', 'close'];

// TODO verify: these figures came with the Rocket export and are unconfirmed.
export const PROOF_STATS = [
  { value: '50K+', label: 'Active Users' },
  { value: '4.9★', label: 'App Store Rating' },
  { value: '2M+', label: 'Rituals Completed' },
  { value: '94%', label: 'Report Positive Shifts' },
];

export const VARIANTS = {
  a: {
    key: 'a',
    name: 'Original',
    eyebrow: 'The #1 inner voice training app',
    headline: ["If you don't train your mind,", 'your mind will train you.'],
    sub: 'Your mind repeats the same thoughts, fears and stories every day. DepthMe gives you personalized daily rituals to help you recognize those patterns and train a different inner dialogue.',
    heroVideo: 'ad-1',
    sectionOrder: ['problem', 'rituals', 'offer', 'proof', 'close'],
    offer: { timer: true },
    ctaLabel: 'Try DepthMe',
  },
  b: {
    key: 'b',
    name: 'Voice-first',
    eyebrow: 'Guided in your own voice',
    headline: ['Hear your rituals', 'in your own voice.'],
    sub: 'Record your voice once. DepthMe turns it into personalized morning intentions, shadow work and night reflections — spoken the way you speak to yourself.',
    heroVideo: 'ad-2',
    sectionOrder: ['rituals', 'offer', 'proof', 'close'],
    offer: { timer: true },
    ctaLabel: 'Hear my first ritual',
  },
  c: {
    key: 'c',
    name: 'Shadow-work pain',
    eyebrow: 'You talk to yourself all day',
    headline: ["“I'm not enough.”", 'What are you repeating?'],
    sub: 'The same five thoughts run on loop. DepthMe helps you notice them, work through them, and practice a new inner dialogue — a few minutes a day.',
    heroVideo: 'ad-1',
    sectionOrder: ['problem', 'proof', 'offer', 'close'],
    offer: { timer: true },
    ctaLabel: 'Change the conversation',
  },
  d: {
    key: 'd',
    name: 'Short',
    eyebrow: 'Five minutes a day',
    headline: ['Train your inner voice,', 'daily.'],
    sub: 'Personalized rituals, guided in your own voice. Start in minutes.',
    heroVideo: 'ad-1',
    sectionOrder: ['offer', 'close'],
    offer: { timer: false },
    ctaLabel: 'Start with DepthMe',
  },
  e: {
    key: 'e',
    name: 'Social-proof-led',
    eyebrow: 'Real people. Real shifts.',
    headline: ['Thousands are already', 'training their mind.'],
    sub: "It's not a meditation app — it's a mind training system, built around your goals, patterns and reflections.",
    heroVideo: 'ad-2',
    sectionOrder: ['proof', 'rituals', 'offer', 'close'],
    offer: { timer: true },
    ctaLabel: 'Join them',
  },
};

export const DEFAULT_VARIANT = 'a';

export const ctaHref = (variantKey) =>
  `${APP_URL}/?src=funnel_${encodeURIComponent(variantKey)}`;
